export const dummyArray2 = [
    {
        id: 1,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 2,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM,Dubai ',
        location2: 'Deira,Dubai',
        StockAvailableQty: '13',
        StockAvailableQty2: '13',



    },
    {
        id: 3,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '14',
        StockAvailableQty2: '13',



    },
    {
        id: 4,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '15',
        StockAvailableQty2: '13',



    },
    {
        id: 5,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '16',
        StockAvailableQty2: '13',



    },
    {
        id: 6,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '17',
        StockAvailableQty2: '13',



    },
    {
        id: 7,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '18',
        StockAvailableQty2: '13',



    },
    {
        id: 8,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '19',
        StockAvailableQty2: '13',



    },
    {
        id: 9,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '20',
        StockAvailableQty2: '13',



    },
    {
        id: 10,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '21',
        StockAvailableQty2: '13',



    },
    {
        id: 11,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '22',
        StockAvailableQty2: '13',



    },
    {
        id: 12,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '23',
        StockAvailableQty2: '13',



    },
    {
        id: 13,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '24',
        StockAvailableQty2: '13',



    },
    {
        id: 14,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '25',
        StockAvailableQty2: '13',



    },
    {
        id: 15,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '26',
        StockAvailableQty2: '13',



    },
    {
        id: 16,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '27',
        StockAvailableQty2: '13',



    },
    {
        id: 17,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '28',
        StockAvailableQty2: '13',



    },
    {
        id: 18,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '29',
        StockAvailableQty2: '13',



    },
    {
        id: 19,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '30',
        StockAvailableQty2: '13',



    },
    {
        id: 20,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 21,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 22,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 23,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 24,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 25,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 26,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 27,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 28,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 29,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 30,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 31,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 32,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 33,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 34,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 35,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 36,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 37,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 38,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 39,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 40,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 41,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 42,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 43,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 44,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 45,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 46,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 47,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 48,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 49,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 50,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 51,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 52,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 53,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        RequiredDeliveryDate: new Date(),
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 54,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 55,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',
    },
    {
        id: 56,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13',



    },
    {
        id: 57,
        MaterialType: 'Steel',
        MaterialCategory: 'Material',
        MaterialCode: '1003010001',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        quantity: 'Enter Quantitiy',
        unit: 'Text',
        RequiredDeliveryDate: new Date(),
        Manufacturer: 'Deira,Dubai',
        ManufacturingModel: 'Text',
        WBSElement: 'Text',
        Plant: 'Text',
        StockAvailableLocation: 'UMM, Dubai',
        location2: 'Deira,Dubai',
        StockAvailableQty: '12',
        StockAvailableQty2: '13'



    },
]